import React, { useEffect, useState } from 'react';
import Navigation from '../Universal/Navigation';
import HeroSection from './HeroSection';
import TechnologySection from './TechnologySection';
import FeaturesSection from './FeaturesSection';
import Model from './Model';
import About from './About';
import Footer from '../Universal/Footer';
import Sponsors from './Sponsors';
import DotGrid from '../DotGrid';
import RetroMode from '../UselessFeature/RetroMode';
import assetUrl from '../../utils/assetUrl';
const HomeTwo = () => {
  const [showModel, setShowModel] = useState(false);
  const [allowModelLoad, setAllowModelLoad] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [modelAvailable, setModelAvailable] = useState(true);
  const [retroEnabled, setRetroEnabled] = useState(false);
  const modelConfigs = {
    default: {
      url: "https://raw.githubusercontent.com/Alectra-Aerospace/Aluren_Web_Models/main/EVE%20full%20stack.glb",
      image: assetUrl('FULL STACK V3.PNG'),
      view: {
        defaultRotationX: 0,
        defaultRotationY: 270,
        defaultRotationZ: 35,
        modelScale: 8,
        modelXOffset: -1.9,
        modelYOffset: -2.95,
        modelZOffset: 0,
        defaultZoom: 5,
        autoRotateAxis: 'z',
        autoRotateSpeed: -0.1785
      }
    },
    fullStack: {
      url: "https://raw.githubusercontent.com/Alectra-Aerospace/Aluren_Web_Models/main/First%20stage%20final.glb",
      image: assetUrl('first-stage-v3.png'),
      view: {
        defaultRotationX: 1.25,
        defaultRotationY: 270,
        defaultRotationZ: 40,
        modelScale: 7.5,
        modelXOffset: -2.25,
        modelYOffset: -2.1,
        modelZOffset: 0,
        defaultZoom: 5,
        autoRotateAxis: 'z',
        autoRotateSpeed: -0.1785
      }
    },
    secondStage: {
      url: "https://raw.githubusercontent.com/Alectra-Aerospace/Aluren_Web_Models/main/EVE%20second%20stage%203070.glb",
      image: assetUrl('Stage 2.PNG'),
      view: {
        defaultRotationX: -1.25,
        defaultRotationY: 270,
        defaultRotationZ: 197,
        modelScale: 8,
        modelXOffset: -1.9,
        modelYOffset: -2.3,
        modelZOffset: 0,
        defaultZoom: 5,
        autoRotateAxis: 'z',
        autoRotateSpeed: -0.1785
      }
    }
  };
  const [selectedModelKey, setSelectedModelKey] = useState('default');
  const selectedModel = modelConfigs[selectedModelKey];

  const handleRetroExitClick = () => {
    window.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape' }));
  };

  useEffect(() => {
    let active = true;
    fetch(selectedModel.url, { method: 'HEAD', cache: 'no-cache' })
      .then((res) => {
        if (!active) return;
        if (!res.ok) setModelAvailable(false);
      })
      .catch(() => {
        if (active) setModelAvailable(false);
      });
    return () => {
      active = false;
    };
  }, [selectedModel.url]);

  useEffect(() => {
    if (!modelAvailable) {
      setShowModel(false);
      setAllowModelLoad(false);
    }
  }, [modelAvailable]);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const handleChange = (event) => {
      setIsMobile(event.matches);
    };

    setIsMobile(mediaQuery.matches);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
    } else {
      mediaQuery.addListener(handleChange);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handleChange);
      } else {
        mediaQuery.removeListener(handleChange);
      }
    };
  }, []);

  useEffect(() => {
    if (isMobile) {
      setShowModel(false);
      setAllowModelLoad(false);
    }
  }, [isMobile]);

  


  return (
    <div className="aero-page" style={{ minHeight: '100vh', color: '#fff', position: 'relative' }}>
      <RetroMode onToggle={setRetroEnabled} />
      {}
      <div style={{ position: 'fixed', inset: 0, backgroundColor: '#000', zIndex: -2 }} />

      {}
      <div style={{ position: 'fixed', inset: 0, zIndex: -1, pointerEvents: 'none' }}>
        <DotGrid
          dotSize={3}
          gap={12}
          baseColor="#000"
          activeColor="#5227FF"
          proximity={50}
          shockRadius={50}
          shockStrength={1}
          resistance={750}
          returnDuration={1.5}
          style={{ width: '100%', height: '100%' }}
        />
      </div>

      {}
      <div style={{ position: 'relative', zIndex: 1, pointerEvents: 'auto' }}>
        <Navigation isRetro={retroEnabled} />
        <HeroSection isRetro={retroEnabled} />
        <About />
        <div style={{ padding: '40px 20px 0', color: '#fff' }}>
          <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: '0.8rem' }}>
              <h2 style={{
                fontSize: 'clamp(2rem, 4vw, 3rem)',
                fontWeight: '100',
                color: 'white',
                marginBottom: '0.2rem',
                letterSpacing: '0.05em'
              }}>
                PLATFORM
              </h2>
            </div>
          </div>
        </div>

        <div className="tech-layout" style={{ display: 'flex', gap: '1.5rem', alignItems: 'stretch', maxWidth: '1400px', margin: '0 auto' }}>
          <div className="tech-text" style={{ flex: '0 0 60%' }}>
            <TechnologySection
              showModel={showModel}
              allowModelLoad={allowModelLoad}
              modelAvailable={modelAvailable}
              isMobile={isMobile}
              onSelectStage={(index) => {
                setShowModel(false);
                if (index === 1) {
                  setSelectedModelKey('fullStack');
                } else if (index === 2) {
                  setSelectedModelKey('secondStage');
                } else {
                  setSelectedModelKey('default');
                }
              }}
              onToggleModel={() => {
                if (isMobile) {
                  return;
                }
                if (showModel) {
                  setShowModel(false);
                } else {
                  setAllowModelLoad(true);
                  setShowModel(true);
                }
              }}
              onRemoveModel={() => {
                setShowModel(false);
                setAllowModelLoad(false);
              }}
            />
          </div>
          <div className="tech-model" style={{ flex: '0 0 40%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 0 60px' }}>
            <Model
              showModel={showModel}
              allowModelLoad={allowModelLoad}
              modelAvailable={modelAvailable}
              modelUrl={selectedModel.url}
              fallbackImageSrc={selectedModel.image}
              viewConfig={selectedModel.view}
            />
          </div>
        </div>
        <FeaturesSection />
        <Sponsors />

        {retroEnabled && (
          <div
            style={{
              position: 'fixed',
              left: 0,
              right: 0,
              bottom: 0,
              padding: '0.5rem 1rem',
              background: '#111',
              color: '#f0f0f0',
              textAlign: 'center',
              fontSize: '0.75rem',
              letterSpacing: '0.08em',
              zIndex: 9999
            }}
          >
            To return to default styling, press{' '}
            <span style={{ color: '#ff6b6b' }}>esc.</span> or press{' '}
            <span
              role="button"
              tabIndex={0}
              onClick={handleRetroExitClick}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleRetroExitClick();
                }
              }}
              style={{ color: '#ff6b6b', cursor: 'pointer', textDecoration: 'underline' }}
            >
              here
            </span>
            .
          </div>
        )}
        
        <Footer />
      </div>
    </div>
  );
};

export default HomeTwo;